<template>
  <div>
    <div class="entry-contents-ttl container-xl text-center">
      <h2>パスワードリセット</h2>
    </div>

    <div class="container-xl px-lg-0">
      <div class="row row-flow">
        <div class="col-3">
          <div class="flow-item rounded-start current">メールアドレス<span>の入力</span></div>
        </div>
        <div class="col-3">
          <div class="flow-item current">ワンタイムパス<span>の入力</span></div>
        </div>
        <div class="col-3">
          <div class="flow-item current">必要事項<span>の入力</span></div>
        </div>
        <div class="col-3">
          <div class="flow-item">完了</div>
        </div>
      </div>
    </div>

    <!-- フォームアイテム --------------------------- -->
    <form @submit.prevent="validate">
      <main class="container-xl">
        <div class="primary-area">
          <section class="primary-section">
          <!-- セクションタイトル --------------------------- -->
            <div class="section-ttl">
              <h3>パスワードをリセットする</h3>
              <div class="small">
                契約ユーザとは、サービスアカウントのすべての設定を閲覧、編集できるユーザです。サービスアカウントを新規で作成した
                ユーザは、自動的にサービスアカウント契約ユーザとなります。
              </div>
            </div>

          <!-- input なし --------------------------- -->
            <dl class="section-item row single-item">
              <dt class="col-md-3">
                メールアドレス
              </dt>
              <dd class="col-md-9">
                {{ formItems.email }}
              </dd>
            </dl>

          <!-- input password --------------------------- -->
            <dl class="section-item row">
              <dt class="col-md-3">
                <label for="" class="col-form-label">
                  新しいパスワード<div class="ico-txt required">必須</div>
                </label>
              </dt>
              <dd class="col-md-9">
                <Input
                  type="password"
                  placeholder="8文字以上の大文字、小文字、数字で構成される半角英数字"
                  required
                  class="form-control"
                  :class="{
                    'form-error': formErrors.resetPassword.getErrorMsg('password'),
                  }"
                  autocomplete="none"
                  v-model="formItems.password1"
                />
                <Input
                  type="password"
                  placeholder="確認のため、もう一度入力してください"
                  required
                  class="form-control mt-2"
                  :class="{
                    'form-error': formErrors.resetPassword.getErrorMsg('password'),
                  }"
                  v-model="formItems.password2"
                />
                <div class="small notes notes-error">
                  {{  this.formErrors.resetPassword.getErrorMsg('password') }}
                </div>
              </dd>
            </dl>

          </section>

          <!-- ボタン --------------------------- -->
          <section class="primary-section text-center">
            <div class="btn-area my-2">
              <Button
                :disabled="!isScreenActive"
              >リセットする</Button>
            </div>
            <div class="text-center mt-3">
              <Link class="small" @click="toSignInForm">ログイン画面に戻る</Link>
            </div>
          </section>
        </div><!-- end .primary-area-->

      </main>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { RepositoryFactory } from "repositories/factory";
import {
  SCREEEN_STATUS_CD,
} from "models/screen-status";
import {
  ResetPasswordValidator,
} from "validators/reset-password";

import {
// Icon,
// Tooltip,
  Button,
  Input,
  Link,
} from "components";

import {
  TipIcon,
} from "icons";

const ResetPasswordRepository = RepositoryFactory.get("reset-password");

export default {
  name: "ResetForm",
  components: {
    Input,
    Link,
    // Icon,
    // Tooltip,
    Button,
  },
  data() {
    return {
      icons: {
        TipIcon,
      },
      states: [],
      formItems: {
        email: "",
        password1: "",
        password2: "",
      },
      formErrors: {
        resetPassword: new ResetPasswordValidator(),
      },
    };
  },
  computed: {
    ...mapGetters({
      isScreenActive: "application/isScreenActive",
      resetPasswordEmailVarification: "email-verification/resetPasswordEmailVarification",
    }),
  },
  async created() {
    // サインアップ用のメール認証情報が存在しなければ、メール入力画面に戻る（主にリロード対策）
    if (!this.resetPasswordEmailVarification) {
      this.$router.push({ name: "ResetPasswordSendAuthCode" });
    } else if (!this.resetPasswordEmailVarification.isVerified()) {
      this.$router.push({ name: "ResetPasswordSendAuthCode" });
    } else {
      this.formItems.email = this.resetPasswordEmailVarification.email;
      await this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
    }
  },
  methods: {
    ...mapActions({
      updateScreenStatusCd: "application/updateScreenStatusCd",
      resetNotification: "notification/resetState",
      setErrorNotification: "notification/setErrorNotification",
      updateResetPasswordNotificationFlag: "application/updateResetPasswordNotificationFlag",
    }),
    async validate() {
      try {
        this.screenStatusCd = SCREEEN_STATUS_CD.PROCESSING;
        await this.resetNotification();

        // バリデーション
        this.formErrors.resetPassword = await ResetPasswordValidator.validate(
          this.formItems.password1,
          this.formItems.password2,
        );
        if (!this.formErrors.resetPassword.result) {
          // バリデーションエラー
          await this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
        } else {
          this.submit();
        }
      } catch (err) {
        console.log(err);
        // TODO: 発生したエラーを画面に反映
        this.setErrorNotification({
          message: "予期せぬエラーが発生しました。",
        });
        await this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
      }
    },
    async submit() {
      try {
        await this.updateScreenStatusCd(SCREEEN_STATUS_CD.PROCESSING);
        await ResetPasswordRepository.resetPassword(
          this.resetPasswordEmailVarification.email,
          this.resetPasswordEmailVarification.accessKey,
          this.resetPasswordEmailVarification.authCode,
          this.formItems.password1,
        );
        await this.updateResetPasswordNotificationFlag(true);
        this.$router.push({ name: "SignInForm" });
      } catch (err) {
        console.log(err);
        // TODO: 発生したエラーを画面に反映
        this.setErrorNotification({
          message: "予期せぬエラーが発生しました。",
        });
        await this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
      }
    },
    toSignInForm() {
      this.$router.push({ name: "SignInForm" });
    },
  },
};
</script>
